import createIcon from '../../createIcon';

/**
 * @component @name VerifiedUser
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMUwzIDVWMTFDMyAxNi41NSA2Ljg0IDIxLjc0IDEyIDIzQzE3LjE2IDIxLjc0IDIxIDE2LjU1IDIxIDExVjVMMTIgMVpNMTAgMTdMNiAxM0w3LjQxIDExLjU5TDEwIDE0LjE3TDE2LjU5IDcuNThMMTggOUwxMCAxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerifiedUser = createIcon('VerifiedUser', [
  [
    'path',
    {
      d: 'M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z',
      key: 'asqc9m',
    },
  ],
]);

export default VerifiedUser;
